var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgMultiChoiceIcon(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M47 50.001H3c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h44c1.654 0 3 1.346 3 3v42.001c0 1.654-1.346 3-3 3zM48 5c0-.552-.449-1-1-1H3c-.551 0-1 .448-1 1v42.001c0 .552.449 1 1 1h44c.551 0 1-.448 1-1V5zm-5 33.001H21a1 1 0 010-2h22a1 1 0 110 2zm0-4H21a1 1 0 010-2h22a1 1 0 110 2zM21 28h16a1 1 0 010 2H21a1 1 0 110-2zm22-6H21a1 1 0 110-2h22a1 1 0 010 2zm0-4H21a1 1 0 110-2h22a1 1 0 010 2zm-6-4H21a1 1 0 110-2h16a1 1 0 110 2zM11 40.001c-3.309 0-6-2.692-6-6A6.007 6.007 0 0111 28c3.308 0 6 2.692 6 6.001 0 3.308-2.692 6-6 6zM11 30c-2.206 0-4 1.794-4 4.001 0 2.206 1.794 4 4 4s4-1.794 4-4A4.004 4.004 0 0011 30zm0 6.001c-1.103 0-2-.898-2-2 0-1.103.897-2 2-2s2 .897 2 2c0 1.102-.897 2-2 2zM11 24c-3.309 0-6-2.691-6-6 0-3.308 2.691-6 6-6 3.308 0 6 2.692 6 6 0 3.309-2.692 6-6 6zm0-10c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  })))));
}
export default SvgMultiChoiceIcon;